<nz-space class="mobile-report-control">
  <app-apdn-select [(ngModel)]="from" class="report-control" (ngModelChange)="fromChange.emit($event)"
    valueField="docCode">
  </app-apdn-select>
  <span class="text-center">
    <span nz-icon nzType="swap-right" nzTheme="outline"></span>
  </span>
  <app-apdn-select [(ngModel)]="to" class="report-control" (ngModelChange)="toChange.emit($event)"
    valueField="docCode"></app-apdn-select>
</nz-space>
